const rsaKeySizes = [
  2048,
  3072,
  4096
  /* TODO add later when backend ready,
  6144 */
]

export default rsaKeySizes
